import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import { useRecoilValue } from 'recoil';
import { authAtom } from '../../_state';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import { Radio, RadioGroup } from '../Inputs/RadioButton';
import FormControlLabel from '@mui/material/FormControlLabel';

const columns = [
  { id: 'radio', label: '선택', minWidth: 10, align: 'center' },
  { id: 'quantity', label: '사용권 수량', minWidth: 60, align: 'right', format: (value) => value.toLocaleString('en-US') },
  { id: 'residualQuantity', label: '잔여 수량', minWidth: 50, align: 'right', format: (value) => value.toLocaleString('en-US') },
  { id: 'createdName', label: '구매자', minWidth: 100, align: 'center' },
  { id: 'endDate', label: '사용권 만료일', minWidth: 100, align: 'center' },
  { id: 'useKind', label: '사용권 종류', minWidth: 100, align: 'center' }
];

export default function ActiveCodeApplication(props) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isDirty }
  } = useForm({
    defaultValues: {
      clientKey: '',
      requestName: ''
    }
  });

  const auth = useRecoilValue(authAtom);

  const { open, handleClose, getDataList } = props;
  const { username, companyName, companyNo, companyId } = auth;
  const [rows, setRows] = useState([]);
  const [couponQuantity, setCouponQuantity] = useState(0);
  const [orderId, setOrderId] = useState(null);

  const activeCodeApplication = async (data) => {
    return await axios.post(`/api/active/`, data);
  };

  const onSubmit = async (data) => {
    if (couponQuantity <= 0) {
      alert('사용권 수량이 0입니다.\n사용권을 구매해 주세요.');
      return;
    }
    if (isDirty) {
      data.orderId = orderId;
      await activeCodeApplication(data)
        .then((response) => {
          alert(response.data.message);
          handleClose();
          getDataList();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  const getCouponQuantity = async () => {
    const response = await axios.get(`/api/coupon/count/${auth.companyId}`);
    setCouponQuantity(response.data.couponQuantity);
  };

  const getCouponList = async () => {
    let params = { approval: 'Y', useYn: 'N', companyId: auth.companyId };

    await axios.get(`/api/active-coupon`, { params }).then(async (result) => {
      await setRows(result.data);
      await setOrderId(result.data[0].id);
    });
  };

  useEffect(async () => {
    if (open) {
      reset({ clientKey: '', requestName: '' });
      let params = {
        companyId: companyId
      };
      await getCouponQuantity();
      await getCouponList();
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title" maxWidth="1500">
      <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1 }}>
        <DialogTitle id="draggable-dialog-title">활성화 코드 신청</DialogTitle>
        <DialogContent dividers>
          <Box>
            <TableContainer component={'div'}>
              <Table size="small">
                <TableRow>
                  <TableCell sx={{ width: 150 }}>회사</TableCell>
                  <TableCell>
                    {companyName} ({companyNo})
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>담당자</TableCell>
                  <TableCell>{username}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>사용 가능 사용권</TableCell>
                  <TableCell>{couponQuantity}</TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </Box>
          <Box sx={{ mt: 3 }}>
            <RadioGroup
              name="orderId"
              id="orderId"
              value={orderId}
              onChange={(e) => {
                setOrderId(e.target.value);
              }}
            >
              <TableContainer component={'div'}>
                <Table size="small">
                  <TableHead>
                    <TableRow on>
                      {columns.map((column) => (
                        <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, rowIdx) => (
                      <TableRow hover key={row.id}>
                        {columns.map((col, colIdx) => {
                          const value = row[col.id];
                          if (col.id == 'radio') {
                            return (
                              <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                                <FormControlLabel key={row.id} value={row.id} control={<Radio {...register('orderId')} />} />
                              </TableCell>
                            );
                          }
                          return (
                            <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                              {col.format && typeof value === 'number' ? col.format(value) : value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </RadioGroup>
          </Box>
          <Box sx={{ mt: 3 }}>
            <TextField
              id="clientKey"
              variant="outlined"
              size="small"
              label="사용자 키"
              sx={{ width: 650 }}
              autoFocus
              error={!!errors.clientKey}
              helperText={errors.clientKey && errors.clientKey.message}
              {...register('clientKey', {
                required: '사용자 키를 입력해주세요.'
              })}
            />
          </Box>
          <Box sx={{ mt: 1 }}>
            <TextField
              id="requestName"
              variant="outlined"
              size="small"
              label="요청자 이름 (식별 정보)"
              sx={{ width: 650 }}
              error={!!errors.requestName}
              helperText={errors.requestName && errors.requestName.message}
              {...register('requestName', {
                required: '요청자 이름 (식별 정보)를 입력해주세요.'
              })}
            />
            <Box>
              <span style={{ fontSize: 'small', margin: '10px 10px 0px 10px' }}>※ 활성화 코드 복구시 사용되니 식별 가능한 정보를 입력해주세요.</span>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <span style={{ color: 'red', fontSize: 'small', margin: '10px 10px 0px 10px' }}>사용권 사용시 취소 및 환불이 불가능합니다. </span>
          <Button type="submit" variant="contained" color="primary">
            신청
          </Button>
          <Button variant="outlined" color="success" onClick={handleClose}>
            닫기
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
